import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Trip Cell Renderer
 * Displays trip code and ID with clickable link to travel
 */
@Component({
  selector: 'app-trip-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  template: `
    <div class="text-secondary text-center">
      <div
        class="flex items-center px-3 cursor-pointer"
        [ngClass]="{ underline: hasTripId }"
        (click)="onTripClick()"
        [matTooltip]="hasTripId ? 'Ir al viaje' : ''">
        <span>{{ tripId }}</span>
        <mat-icon
          *ngIf="hasTripId"
          class="ml-2 icon-size-3 hover:animate-bounce"
          svgIcon="heroicons_outline:rocket-launch"
          style="color: rgb(0, 0, 0)">
        </mat-icon>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
    .table-text-code {
      font-size: 0.75rem;
      color: #6b7280;
    }
    .underline {
      text-decoration: underline;
    }
  `]
})
export class TripCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  get code(): string | null {
    const trip = this.params?.data?.trip;
    if (!trip) return null;

    const code = trip?.externalKeys?.code;
    return code || null;
  }

  get tripId(): string {
    return this.params?.data?.trip?.id ? String(this.params.data.trip.id) : '-';
  }

  get hasTripId(): boolean {
    return !!this.params?.data?.trip?.id;
  }

  onTripClick(): void {
    if (this.hasTripId && this.params?.onTripClick) {
      this.params.onTripClick(this.params.data);
    }
  }
}
